import { render, staticRenderFns } from "./TicketKanbanBoard.vue?vue&type=template&id=f794a8c8"
import script from "./TicketKanbanBoard.vue?vue&type=script&lang=js"
export * from "./TicketKanbanBoard.vue?vue&type=script&lang=js"
import style0 from "./TicketKanbanBoard.vue?vue&type=style&index=0&id=f794a8c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports